import { render, staticRenderFns } from "./WhatsappFloat.vue?vue&type=template&id=75280f41&scoped=true"
import script from "./WhatsappFloat.vue?vue&type=script&lang=js"
export * from "./WhatsappFloat.vue?vue&type=script&lang=js"
import style0 from "./WhatsappFloat.vue?vue&type=style&index=0&id=75280f41&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75280f41",
  null
  
)

export default component.exports